import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type { ContextoAcessoParte } from '@/types/contextoAcesso/types';

const base = (state: RootState) => state.contextoAcesso;

export const selectContextos = createSelector(base, (s) => s.contextos);
export const selectUltimoContexto = createSelector(base, (s) => s.ultimoContexto);
export const selectContextosCarregando = createSelector(base, (s) => s.loading);
export const selectTrocandoContexto = createSelector(base, (s) => s.trocando);
export const selectErroContextos = createSelector(base, (s) => s.error);

const ehParte = (contexto: { tipo: string }): contexto is ContextoAcessoParte =>
  contexto.tipo !== 'WORKSPACE';

/**
 * Processos em que a pessoa é parte e que ela ainda não abriu. Alimenta o aviso
 * persistente: some quando ela abre o processo, não quando fecha o aviso.
 */
export const selectContextosNaoAbertos = createSelector(selectContextos, (contextos) =>
  contextos.filter(ehParte).filter((contexto) => contexto.naoAberto),
);

/**
 * Só as participações em processo. A troca de WORKSPACE continua sendo do
 * `WorkspaceSwitcher`, que além de persistir a preferência faz o que de fato
 * muda o workspace do cliente: `setStoredWorkspaceId` (que alimenta o header
 * `X-Workspace-Id`), recarga da sessão e das listas. Duplicar isso aqui criaria
 * dois estados de workspace divergentes na mesma sessão.
 */
export const selectContextosDeParte = createSelector(selectContextos, (contextos) =>
  contextos.filter(ehParte),
);

/** A conta é parte em algum processo — é o caso que justifica o switcher aparecer. */
export const selectTemContextoDeParte = createSelector(
  selectContextosDeParte,
  (partes) => partes.length > 0,
);
